import { useWSModal, WSList, WSLoader } from "@wingspanhq/fe-component-library";
import { queriesPersons } from "@query";
import { useSession } from "@hooks/useSession";
import { DataView } from "../../../../../shared/components/DataView";
import { phoneNumberToFormData } from "../../../../Onboarding/components/FormPartialPhoneNumber";
import { MfaFactorsSection } from "../../../../../v3/components/MfaFactors/MfaFactorsSection";
import { FormAddPassword } from "../components/FormAddPassword";
import { FormChangePassword } from "../components/FormChangePassword";

type Props = {};

export const RouteAccount: React.FC<Props> = () => {
  const { personId } = useSession();
  const queryPerson = queriesPersons.getPerson.useQuery({ personId });

  const modalChangePassword = useWSModal(FormChangePassword, {
    title: "Change password",
    size: "S"
  });
  const modalAddPassword = useWSModal(FormAddPassword, {
    title: "Add password",
    size: "S"
  });

  if (queryPerson.isInitialLoading) {
    return <WSLoader.Spinner />;
  }

  const person = queryPerson.data;
  const phoneNumber = person?.phone || undefined;
  const defaultPhone = phoneNumber
    ? phoneNumberToFormData(phoneNumber, "US")
    : undefined;

  return (
    <WSList gap="2XL">
      <DataView
        title="Account information"
        data={[
          {
            label: {
              text: "Sign-in email"
            },
            value: person?.email || undefined
          },
          {
            label: {
              text: "Phone number"
            },
            value: person?.phone || undefined
          },
          {
            label: {
              text: "Password",
              action: person?.hasCredentialsConfigured
                ? {
                    label: "Edit",
                    onClick: () => {
                      modalChangePassword.open();
                    }
                  }
                : {
                    label: "Add",
                    onClick: () => {
                      modalAddPassword.open();
                    }
                  },
              actionPosition: "left"
            },
            value: person?.hasCredentialsConfigured
              ? "********"
              : "Password is not added yet"
          }
        ]}
      />

      <MfaFactorsSection
        defaultEmail={person?.email || undefined}
        defaultPhone={defaultPhone}
      />
    </WSList>
  );
};
